import '../styles/app.scss';
import 'slick-carousel/slick/slick.scss';
import Accordion from '../../components/accordion/index';
import AnchorScroll from '../../components/anchor-scroll/index';
import ButtonUp from '../../components/button-up/index';
import MobileMenu from '../../components/mobile-menu/index';
import Rates from '../../components/rates/index';
import Spoiler from '../../components/spoiler/index';
import SwitchLanguage from '../../components/switch-language/index';
import 'slick-carousel';
import {ACCEPT_PARAM_NAME} from './constants';
import Utils from './utils';

// init slider about for mobile
const $sliderAbout = $('.j-slider-about');

if ($sliderAbout.length) {
    const options = {
        mobileFirst: true,
        responsive : [{
            breakpoint: 0,
            settings  : {
                dots        : true,
                dotsClass   : 'b-about__list-dots',
                arrows      : false,
                speed       : 300,
                slidesToShow: 1,
                infinite    : true
            }

        }, {
            breakpoint: 767,
            settings  : 'unslick'

        }]
    };

    $sliderAbout.slick(options);
}

// init slider of programs
const $sliderPrograms = $('.j-slider-programs');

if ($sliderPrograms.length) {
    const options = {
        mobileFirst  : true,
        dots         : false,
        speed        : 300,
        infinite     : true,
        variableWidth: true,
        prevArrow    : $('.j-slider-programs-arrow-prev'),
        nextArrow    : $('.j-slider-programs-arrow-next'),
        responsive   : [{
            breakpoint: 0,
            settings  : {
                arrows      : false,
                centerMode  : true,
                slidesToShow: 1
            }
        }, {
            breakpoint: 1199,
            settings  : {
                arrows      : true,
                centerMode  : false,
                slidesToShow: 2

            }
        }, {
            breakpoint: 1439,
            settings  : {slidesToShow: 3}
        }, {
            breakpoint: 1919,
            settings  : {slidesToShow: 4}
        }]
    };

    $sliderPrograms.slick(options);
}

// init anchor scroll
const anchorScrolls = $('.j-anchor-scroll');

if (anchorScrolls.length) {
    const anchorScroll = new AnchorScroll(anchorScrolls);

    anchorScroll.bindEvent();
}

// init buy link
const $buyWrapper = $('.j-buy-wrapper');

if ($buyWrapper.length) {
    const buy = new Buy($buyWrapper);

    buy.bindEvent();
}

// init mobile menu
const $mobileMenu = $('.j-mobile-menu');

if ($mobileMenu.length) {
    const mobileMenu = new MobileMenu($mobileMenu);

    mobileMenu.init();
}

// init spoiler
const $spoilerElement = $('.j-spoiler');

if ($spoilerElement.length) {
    const spoiler = new Spoiler($spoilerElement);

    spoiler.init();
}

// init spoiler
const $switchButton = $('.j-switch-button');

if ($switchButton.length) {
    const switchLanguage = new SwitchLanguage($switchButton);

    switchLanguage.init();
}

// init accordion
const $accordions = $('.j-accordion');

if ($accordions.length) {
    $accordions.each((item, accrodion) => {
        const accordion = new Accordion($(accrodion));

        accordion.init();
    });
}

// init button-up
const $buttonUp = $('.j-button-up');
const $firstScreen = $('.b-home__section_firts_screen');
let updateParams = null;

if ($buttonUp.length) {
    const buttonUp = new ButtonUp($buttonUp, $firstScreen);

    buttonUp.init();

    updateParams = () => {
        buttonUp.updateParams();
    };
}

// init rates
const $rates = $('.j-rates');

if ($rates.length) {
    const rates = new Rates($rates, updateParams);

    rates.init();
}

// init agree cookie
const $cookieMessage = $('.j-cookie-message');

if ($cookieMessage.length) {
    if (!Utils.getAcceptance(ACCEPT_PARAM_NAME)) {
        $cookieMessage.show();
    }
    const $cookieMessageBtn = $cookieMessage.find('.j-cookie-message-btn');

    $cookieMessageBtn.on('click', () => {
        Utils.setAcceptance(ACCEPT_PARAM_NAME, 'y');
        $cookieMessage.fadeOut();
    });
}
